export const EMPTY_DATE = "—";

// LMS reports are filtered and exported on Kyiv calendar days; the tables must show the same day
// regardless of the admin's browser timezone. new Date(null) is the Unix epoch, hence the guard.
export const formatKyivDate = (
  value: string | Date | null | undefined
): string =>
  value
    ? new Date(value).toLocaleDateString("uk-UA", { timeZone: "Europe/Kyiv" })
    : EMPTY_DATE;
